export default __webpack_public_path__ + "static/media/placeholder_dummy2016-kunsthandwerk01-mobile-de.21a2df88.png";